export enum ESessionStorageKeys {
  Token = 'token',
}
